import { Typography } from 'antd';
import Paragraph from 'antd/es/typography/Paragraph';

const { Text } = Typography;

interface NoteTextProps {
  note: string;
  label: string;
}

const NoteText = ({ note, label = 'Ghi chú' }: NoteTextProps) => {
  return (
    <Paragraph
      style={{ marginBlockEnd: 0 }}
      ellipsis={{
        rows: 2,
        tooltip: {
          placement: 'rightTop',
          color: '#4f606b',
          title: (
            <Text>
              <Text
                style={{
                  color: '#d9d9d9'
                }}
              >
                {label}:{' '}
              </Text>{' '}
              <Text
                style={{
                  color: 'white'
                }}
              >
                {note}
              </Text>
            </Text>
          )
        }
      }}
    >
      <Text>
        <Text type='secondary'>{label}: </Text>
        <Text>{note}</Text>
      </Text>
    </Paragraph>
  );
};

export default NoteText;
